import Webgl from './Webgl';
import { IS_SERVER } from '@af-app/config';

export default class Framebuffer {
	private webgl:Webgl;

	public name:string;
	public core:WebGLFramebuffer;
	public texture:WebGLTexture;
	public drawCount:number;
	public width:number;
	public height:number;

	constructor(_name:string, _width:number, _height:number, _webgl:Webgl) {
		this.name = _name;
		this.width = _width;
		this.height = _height;
		this.webgl = _webgl;
		this.drawCount = 0;

		this.init();
	}

	public delete = () => {
		if(this.webgl.gl.isTexture(this.texture)) {
			this.webgl.gl.deleteTexture(this.texture);
		}

		if(this.webgl.gl.isFramebuffer(this.core)) {
			this.webgl.gl.deleteFramebuffer(this.core);
		}
	}

	private init = () => {
		let gl = this.webgl.gl;

		let buffer = gl.createFramebuffer();
		let texture = gl.createTexture();

		gl.bindFramebuffer(gl.FRAMEBUFFER, buffer);
		gl.bindTexture(gl.TEXTURE_2D, texture);
		gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
		if(IS_SERVER){
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
		} else {
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
		}
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

		gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
		gl.bindFramebuffer(gl.FRAMEBUFFER, null);

		this.core = buffer;
		this.texture = texture;
	}
}